import React, { StrictMode, Suspense } from 'react'
import { createRoot } from 'react-dom/client'

import './index.css'

const App = React.lazy(() => import("./App"));

createRoot(document.getElementById('root')).render(
    <StrictMode>
        <Suspense>
            <App />
        </Suspense>
    </StrictMode>
)
